import React, { useState, useEffect } from 'react';
import { getAccountInfo } from "../../services/backendApi";
import {getProjects} from "../../services/api";
import * as styled from "./styled";
import Spinner from "../presentation/spinner";

const GeneralStats = () => {
    const [productionAccounts, setProductionAccounts] = useState()
    // Account integrations is an object with { account, integrations } where integrations is an array of strings of integration names
    const [accountIntegrations, setAccountIntegrations] = useState()
    const [integrationsList, setIntegrationList] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const getProductionAccounts = async () => {
            const accounts = await getAccountInfo()
            const targetAccounts = accounts.filter(account => account.type === 'Production').sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            })
            setProductionAccounts(targetAccounts)
        }
        getProductionAccounts()
    }, [])

    useEffect(() => {
        const getAccountIntegrations = async () => {
            const idToken = localStorage.getItem('idToken')
            const allIntegrationNames = new Set()
            const getAccountIntegrationsPromises = productionAccounts.map(async (account) => {
                const foundIntegrations = account.integrations ? Object.keys(account.integrations) : []
                const projectIntegrations = new Set()
                const projects = await getProjects(account._id, idToken)
                projects.forEach(project => {
                    if(project.integrations){
                        const integrationNames = Object.keys(project.integrations)
                        if(integrationNames.length){
                            integrationNames.forEach(integrationName => projectIntegrations.add(integrationName))
                        }
                    }
                    if(project.webhooks?.length){
                        project.webhooks.forEach(webhook => {
                            const STANDARD_WEBHOOK_STRUCTURES = ['standard', 'default', '2.0']
                            if(!webhook.structure || STANDARD_WEBHOOK_STRUCTURES.includes(webhook.structure)){
                                projectIntegrations.add('webhooks')
                            }else{
                                projectIntegrations.add(webhook.structure)
                            }
                        })
                    }
                })
                const allIntegrations = [...foundIntegrations, ...projectIntegrations]
                allIntegrations.forEach(integrationName => allIntegrationNames.add(integrationName))
                return { account, integrations: allIntegrations}
            })
            const results = await Promise.all(getAccountIntegrationsPromises)
            setIntegrationList([...allIntegrationNames].sort())
            setAccountIntegrations(results)
            console.log('integration', allIntegrationNames)
            setIsLoading(false)
        }
        if(productionAccounts?.length){
            setIsLoading(true)
            getAccountIntegrations()
        }
    }, [productionAccounts])

    if (isLoading) {
        return (
            <styled.IntegrationsListWrapper>
                <Spinner size={200} />
            </styled.IntegrationsListWrapper>
        );
    }

    return (
        <styled.IntegrationsListWrapper>
            <styled.TableTitle>Production Account Integrations</styled.TableTitle>
            <styled.TableDescription>This table lists all customers tagged as "Production" and their corresponding active backend integrations. If you don&apos;t see a particular integration listed, it means none of the production customers currently have it enabled. Please note that this table does not include SDK-to-SDK integrations.</styled.TableDescription>
            <styled.IntegrationsTable>
                <styled.TableHeader>
                    <styled.TableRow>
                        <styled.HeaderCell>Account Name</styled.HeaderCell>
                        {integrationsList.map(integration => <styled.HeaderCell key={integration}>{`${integration.charAt(0).toUpperCase()}${integration.slice(1)}`}</styled.HeaderCell>)}
                    </styled.TableRow>
                </styled.TableHeader>
                <styled.TableBody>
                    {accountIntegrations.map(accountData => (
                        <styled.TableRow key={accountData.account._id}>
                            <styled.TableCell>{accountData.account.name}</styled.TableCell>
                            {integrationsList.map(integration => (
                                <styled.HeaderCell key={`${accountData.account._id}-${integration}`}>
                                    <styled.StatusIndicator valid={accountData.integrations.includes(integration)}/>
                                </styled.HeaderCell>
                            ))}
                        </styled.TableRow>
                    ))}
                </styled.TableBody>
            </styled.IntegrationsTable>
        </styled.IntegrationsListWrapper>
    );
}
export default GeneralStats